import Repository from '@/repositories/marketing'
const resource = '/content_templates'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    preview(content_id,config){
        return Repository.get(`${resource}/${content_id}/preview.json`,config)
    },
    duplicateName(config){
        return Repository.post(`${resource}/find_duplicate_content_template.json`,config)
    },
    delete(config){
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    deleteSelected(content_id){
        return Repository.delete(`${resource}/${content_id}.json`)
    },
    saveContentAsTemplate (payload) {
        return Repository.post(`${resource}.json`, payload)
    },
    show (templateId, config) {
        return Repository.get(`${resource}/${templateId}.json`, config)
    },
    update (contentId, payload, config) {
        return Repository.put(`${resource}/${contentId}.json`, payload, config)
    },
    validateName(config){
        return Repository.get(`${resource}/validate_name.json`, config);
    },
    getPermissions(config){
        return Repository.get(`${resource}/get_permissions.json`, config);
    }
}
